// public/js/components/input.js

const CLASSES = {
  valid: ['bg-green-50', 'border-green-600', 'focus:ring-green-600'],
  invalid: ['bg-red-50', 'border-red-600', 'focus:ring-red-600'],
  neutral: ['bg-white', 'border-slate-600', 'focus:ring-green-600']
};

export default function Input(rootEl) {
  const input = rootEl.querySelector('input, textarea');
  const errorDiv = rootEl.querySelector('[data-ref="error"]');

  if (!input) return;

  if (errorDiv) {
    const errorId = errorDiv.id || `err-${Math.random().toString(36).substring(2, 11)}`;
    errorDiv.id = errorId;
    input.setAttribute('aria-describedby', errorId);
  }

  let hasBlurred = false;

  const setVisualState = (state, message = '') => {
    requestAnimationFrame(() => {
      if (errorDiv) {
        errorDiv.textContent = message;
        if (message) errorDiv.classList.remove('hidden');
        else errorDiv.classList.add('hidden');
      }

      input.classList.remove(
        ...CLASSES.valid,
        ...CLASSES.invalid,
        ...CLASSES.neutral
      );

      switch (state) {
        case 'valid':
          input.setAttribute('aria-invalid', 'false');
          input.classList.add(...CLASSES.valid);
          break;
        case 'invalid':
          input.setAttribute('aria-invalid', 'true');
          input.classList.add(...CLASSES.invalid);
          break;
        default:
          input.setAttribute('aria-invalid', 'false');
          input.classList.add(...CLASSES.neutral);
      }
    });
  };

  // UPDATED: Now returns boolean (true = valid, false = invalid)
  const validate = () => {
    const isValid = input.validity.valid;
    const value = input.value.trim();

    if (value.length === 0) {
      if (input.hasAttribute('required')) {
        setVisualState('invalid', 'This field is required.');
        return false;
      } else {
        setVisualState('neutral');
        return true;
      }
    } else if (!isValid) {
      setVisualState('invalid', input.validationMessage);
      return false;
    } else {
      setVisualState('valid');
      return true;
    }
  };

  rootEl.validate = validate;

  const matchId = rootEl.dataset.match;
  if (matchId) {
    const matchTarget = document.getElementById(matchId);
    if (matchTarget) {
      const checkMatch = () => {
        if (input.value && input.value !== matchTarget.value) {
          input.setCustomValidity('Passwords do not match.');
        } else {
          input.setCustomValidity('');
        }
      };

      // Initialize
      checkMatch();

      // Update validity on input
      input.addEventListener('input', checkMatch);

      // Re-validate when target changes
      matchTarget.addEventListener('input', () => {
        checkMatch();
        if (hasBlurred) validate();
      });
    }
  }

  input.addEventListener('blur', () => {
    hasBlurred = true;
    validate();
  });

  input.addEventListener('input', () => {
    if (hasBlurred) validate();
  });

  input.addEventListener('invalid', (e) => {
    e.preventDefault(); // Stop browser bubble
    hasBlurred = true;
    validate();
  });

  if (input.value && input.value.trim() !== '') {
    validate();
  }
}